import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from '@ui-modules/informed';
import { IDropdownOption } from '@ui-modules/types';

interface IDriverBloodGroupField {
  defaultValue?: number;
  disabled?: boolean;
}

const options: IDropdownOption[] = [
  { value: '', label: '--' },
  { value: '0', label: 'A+' },
  { value: '1', label: 'A-' },
  { value: '2', label: 'B+' },
  { value: '3', label: 'B-' },
  { value: '4', label: 'O+' },
  { value: '5', label: 'O-' },
  { value: '6', label: 'AB+' },
  { value: '7', label: 'AB-' },
];

const DriverBloodGroupField: FC<IDriverBloodGroupField> = ({ defaultValue, disabled }) => {
  const { t } = useTranslation();

  return (
    <div className="field field-blood-group">
      <Dropdown
        defaultValue={options.find((option) => parseFloat(option.value) === defaultValue)}
        isDisabled={disabled}
        label={t('mobility.bloodGroup')}
        name="bloodGroup"
        options={options}
      />
    </div>
  );
};

export default DriverBloodGroupField;
